import { ArrowDownThin } from '@ori-ui/icons';
const styleOverrides = {
  standard: {
    '&:focus': {
      backgroundColor: 'unset'
    }
  },
  outlined: {
    borderRadius: 5
  }
};
const defaultProps = {
  IconComponent: ArrowDownThin,
  MenuProps: {
    elevation: 0,
    classes: {
      paper: 'OriSelectPaper',
      list: 'OriSelectList'
    },
    BackdropProps: {
      invisible: true
    }
  }
};
export default {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiSelect.js.map